// Root state machine: welcome ↔ shell.

import { LocalVault } from '../storage/local-vault.js';
import { AutoLock } from '../storage/auto-lock.js';
import { PuterSync } from '../sync/puter-sync.js';
import { renderWelcome } from './welcome.js';
import { renderShell } from './shell.js';
import { closeAll as closeAllSheets } from './sheet.js';

export function mountApp(root) {
  const vault = new LocalVault();
  let shellApi = null;
  let autoLock = null;
  let sync = null;

  function clearTransientUI() {
    closeAllSheets();
    // .menu-popup included: a desktop menu left open across a lock floats over
    // the unlock screen, and its actions (Export backup…) then run against a
    // locked vault and reject with nothing shown to the user.
    document.querySelectorAll('.modal-backdrop, .toast, .menu-popup').forEach((n) => n.remove());
  }

  function showWelcome() {
    shellApi?.destroy?.();
    shellApi = null;
    // Close sheets BEFORE dropping autoLock. Sheets that paused auto-lock
    // resume it from their onDismiss (form.js, import.js, csv-import.js) via a
    // captured reference; tearing autoLock down first meant closeAll() re-armed
    // an instance this module had already let go of. That orphan kept its
    // document listeners and its onLock -> showWelcome forever, so a later
    // edit session could be killed mid-typing by a timer nobody could stop.
    clearTransientUI();
    autoLock?.stop();
    autoLock = null;
    sync?.stop();
    sync = null;
    renderWelcome(root, { vault, onUnlocked: showShell });
  }

  function showShell() {
    autoLock = new AutoLock(vault, {
      timeoutMs: 5 * 60 * 1000,
      target: document,
      onLock: () => showWelcome(),
    });
    autoLock.start();
    sync = globalThis.puter ? new PuterSync({ vault }) : null;
    shellApi = renderShell(root, {
      vault,
      autoLock,
      sync,
      onLocked: showWelcome,
    });
  }

  showWelcome();
}
